import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "@teamhanko/hanko-elements";

const hankoApi = process.env.BUN_PUBLIC_HANKO_API_URL  as string;

export function HankoAuth() {
  const navigate = useNavigate();

  const redirectAfterLogin = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  useEffect(() => {
    register(hankoApi).catch((error) => {
      console.error("Failed to register Hanko elements:", error);
    });
  }, []);

  useEffect(() => {
    const handleSessionCreated = () => {
      redirectAfterLogin();
    };

    document.addEventListener("hankoAuthSuccess", handleSessionCreated);

    return () => {
      document.removeEventListener("hankoAuthSuccess", handleSessionCreated);
    };
  }, [redirectAfterLogin]);

  return <hanko-login />;
}
